// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"d3a5a582","80":"542ec873","217":"cfd8c949","286":"742dfb26","327":"da4a82d8","462":"82ae60e4","511":"5954f77f","747":"11d60c17","749":"b128b6fd","755":"17b807dd","950":"9c58ea88"}[chunkId] + ".chunk.js";
};